import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from 'src/app/services/language.service';

@Component({
    selector: 'question-print',
    template:`
    <div class="modal-header">
  <h4 class="modal-title">{{message}}</h4>
    <button type="button" class="close" style="margin-left: 0;" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    
    <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="customerPrint()" type="button" class="btn btn-warning">Customer Receipt</button>
        <button (click)="ownPrint()" type="button" class="btn btn-info">Own Receipt</button>
        <button (click)="edit()" type="button" class="btn btn-primary">{{editText}}</button>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger m-1" (click)="dismiss()">{{ cancelText }}</button>
  </div>
    `
})


export class QuestionPrintComponent implements OnInit {
    constructor(private activeModal: NgbActiveModal,private langaugeService:LanguageService) { }
      //1 delele
      //2 add or edit
      //3 havale
      //
    message:string;
    editText:string;
    cancelText:string;
    value:number;
    ngOnInit() {
      this.editText =   this.langaugeService.translate('edit');
      this.cancelText = this.langaugeService.translate('cancel');
    }


    public edit() {
      
      this.activeModal.close(3);
    }

    public dismiss() {
        this.activeModal.close(false);
        // this.activeModal
    }

    public customerPrint(){
        //this.activeModal.close(1)
        

    }
    public ownPrint() {
        //this.activeModal.close(2);
    }
}